import Skeleton from '@mui/material/Skeleton';
import styled from '@emotion/styled';
import Transition from 'presentations/views/components/atoms/Transition';

interface Props {
  view?: string;
  width?: number | string;
  height?: number | string;
  variant?: 'rectangular' | 'text' | 'circular' | 'rounded';
}

export default function Component(props: Props) {
  let comp = null;
  if (props.view) {
    switch (props.view) {
      case 'DatePicker':
        comp = (
          <DatePicker>
            <Inner>
              <DatePickerRow animation="wave" />
              <DatePickerRow animation="wave" />
              <DatePickerRow animation="wave" />
              <DatePickerRow animation="wave" />
              <DatePickerRow animation="wave" />
              <DatePickerRow animation="wave" />
              <DatePickerRow animation="wave" />
            </Inner>
          </DatePicker>
        );
        break;
      case 'EventTypeListItem':
        comp = (
          <DatePicker>
            <Inner>
              <DatePickerRow animation="wave" />
              <DatePickerRow animation="wave" />
            </Inner>
          </DatePicker>
        );
        break;
      default:
        return null;
    }
  } else {
    comp = (
      <Skeleton
        animation="wave"
        variant={props.variant}
        width={props.width}
        height={props.height}
      />
    );
  }
  return (
    <Transition name="fade" in={true}>
      {comp}
    </Transition>
  );
}

const DatePicker = styled.div`
  width: 260px;
  height: 310px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Inner = styled.div`
  width: 100%;
`;
const DatePickerRow = styled(Skeleton)`
  margin-bottom: 12px;
`;
